// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { mediaMax } from 'components/styles/_media'
import { imagePath } from 'frontend_core/dist/helpers/image'
import {
  businessUrl,
  wwwUrl,
  helpUrl,
  accountSignUpUrl,
} from 'frontend_core/dist/helpers/url'
import Path from 'routes/path'

const SiteFooterBottom = styled.div`
  background-color: #2a2a2a;
  color: #fff;
  line-height: 1.5;
  padding: 32px 0;
  ${mediaMax.tablet`
    padding: 20px 0 10px;
  `};
`
const Links = styled.div`
  float: left;
  width: 80%;
  ${mediaMax.tablet`
    width: 100%;
  `};
`
const ComList = styled.ul`
  display: block;
  padding: 0 0 10px;
  ${mediaMax.tablet`
    text-align: center;
    padding-top: 12px;
  `};
`
const ComListItem = styled.li`
  display: inline-block;
  padding: 0 16px 0 0;
`
const ComLink = styled.a`
  color: #fff;
  font-size: 12px;

  &:visited {
    color: #fff;
  }

  &:hover {
    color: #ccc;
  }

  ${mediaMax.tablet`
    display: block;
    padding: 8px;
  `};
`
const SnsList = styled.ul`
  display: block;
  position: relative;
  ${mediaMax.tablet`
    text-align: center;
  `};
`
const SnsListItem = styled.li`
  display: inline-block;
  padding: 0 16px 0 0;
  ${mediaMax.tablet`
    padding: 0 8px;
  `};
`
const Sns = styled.a`
  color: #fff;
  font-size: 24px;

  &:hover {
    color: #ccc;
    text-decoration: none;
  }

  &:visited {
    color: #fff;
  }
`
const Copyrights = styled.div`
  display: block;
  color: #c9c9c9;
  ${mediaMax.tablet`
    text-align: center;
    margin-bottom: 8px;
  `};
`
const CopyrightsSmall = styled.small`
  display: block;
  padding-top: 10px;
  color: #c9c9c9;
`

const ServiceLogo = styled.div`
  text-indent: -9999px;
  height: 45px;
  background: 0 center no-repeat;
  background-size: 100% auto;
  ${({ logoImagePath }) =>
    logoImagePath &&
    css`
    background-image: url("${logoImagePath}");
  `} background-repeat: no-repeat;
  ${mediaMax.tablet`
    width: 100%;
    background-size: 200px auto;
    background-position:center center;
  `};
`

export default () => (
  <SiteFooterBottom>
    <div className="container">
      <div className="row site-footer__nav-header">
        <div className="footer-logo">
          <ServiceLogo logoImagePath={imagePath('logo-white.svg')}>
            スペースマーケット
          </ServiceLogo>
        </div>
        <div className="footer-entry-btn">
          <a href={accountSignUpUrl()} className="pt15 pb15 w100pa button-blue">
            アカウント登録する
          </a>
        </div>
        <div className="footer-entry-btn">
          <a
            href={wwwUrl('/pages/host_entry')}
            className="pt15 pb15 w100pa button-green"
          >
            ホスト登録する
          </a>
        </div>
      </div>

      <div className="site-footer__nav">
        <div>
          <h3 className="site-footer__nav-title sm-hide__guteter">
            目的から探す
          </h3>
          <ul className="site-footer__nav-link sm-hide__guteter">
            <li>
              <a href={wwwUrl('/event_types/party')}>
                {i18n.t('eventTypeLong.party')}
              </a>
            </li>
            <li>
              <a href={wwwUrl('/event_types/class')}>
                {i18n.t('eventTypeLong.class')}
              </a>
            </li>
            <li>
              <a href={Path.staySearch()}>{i18n.t('eventTypeLong.stay')}</a>
            </li>
            <li>
              <a href={wwwUrl('/event_types/photo_shoot')}>
                {i18n.t('eventTypeLong.photo_shoot')}
              </a>
            </li>
            <li>
              <a href={wwwUrl('/event_types/film_shoot')}>
                {i18n.t('eventTypeLong.film_shoot')}
              </a>
            </li>
            <li>
              <a href={wwwUrl('/event_types/studio')}>
                {i18n.t('eventTypeLong.studio')}
              </a>
            </li>
            <li>
              <a href={wwwUrl('/event_types/performance')}>
                {i18n.t('eventTypeLong.performance')}
              </a>
            </li>
            <li>
              <a href={wwwUrl('/event_types/sports')}>
                {i18n.t('eventTypeLong.sports')}
              </a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="site-footer__nav-title sm-hide__guteter">
            カテゴリーから探す
          </h3>
          <ul className="site-footer__nav-link sm-hide__guteter">
            <li>
              <a href={wwwUrl('/event_types')}>目的から探す</a>
            </li>
            <li>
              <a href={wwwUrl('/areas')}>エリアから探す</a>
            </li>
            <li>
              <a href={wwwUrl('/capacities')}>人数から探す</a>
            </li>
            <li>
              <a href={wwwUrl('/space_types')}>会場タイプから探す</a>
            </li>
            <li>
              <a href={wwwUrl('/amenities')}>アメニティから探す</a>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="site-footer__nav-title sm-hide__guteter">
            ご利用ガイド
          </h3>
          <ul className="site-footer__nav-link site-footer__nav-link-guide sm-hide__guteter">
            <li>
              <h4 className="site-footer__heading">ゲスト編</h4>
              <ul>
                <li>
                  <a href={wwwUrl('/about/how_it_works')}>ご利用の流れ</a>
                </li>
                <li>
                  <a href={wwwUrl('/about/payment_flow')}>決済の流れ</a>
                </li>
                <li>
                  <a href={wwwUrl('/about/how_to_stay')}>当日の流れ</a>
                </li>
                <li>
                  <a href={wwwUrl('/about/trust')}>安心への取り組み</a>
                </li>
              </ul>
            </li>
            <li>
              <h4 className="site-footer__heading">ホスト編</h4>
              <ul>
                <li>
                  <a href={wwwUrl('/about/listing')}>掲載するには</a>
                </li>
                <li>
                  <a href={wwwUrl('/about/how_it_works_host')}>ご利用の流れ</a>
                </li>
                <li>
                  <a href={wwwUrl('/about/payment_flow_owner')}>決済の流れ</a>
                </li>
                <li>
                  <a href={wwwUrl('/about/how_to_host')}>当日の対応</a>
                </li>
                <li>
                  <a href={wwwUrl('/about/hospitality')}>
                    人気スペースにするには
                  </a>
                </li>
                <li>
                  <a href={wwwUrl('/about/host_trust')}>信頼への取り組み</a>
                </li>
                <li>
                  <a href={wwwUrl('/pages/host_entry')}>
                    ホスト登録をお考えの方へ
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div>
          <h3 className="site-footer__nav-title sm-hide__guteter">
            スペースマーケットについて
          </h3>
          <ul className="site-footer__nav-link sm-hide__guteter">
            <li>
              <a href={wwwUrl('/about/app')}>スマートフォンアプリ</a>
            </li>
            <li>
              <a
                href="https://beyond.spacemarket.com/know-how/enterprise-use/?utm_source=footer&utm_medium=referral&utm_campaign=business_lp"
                target="_blank"
              >
                法人のご利用について
              </a>
            </li>
            <li>
              <a href={businessUrl('')}>法人向け管理サービス</a>
            </li>
            <li>
              <a href={wwwUrl('/about/privacy')}>プライバシーポリシー</a>
            </li>
            <li>
              <a href={wwwUrl('/about/terms')}>スペースマーケット利用規約</a>
            </li>
            <li>
              <a href={wwwUrl('/about/terms_of_space_use')}>ゲスト規約</a>
            </li>
            <li>
              <a href={helpUrl()}>よくある質問</a>
            </li>
            <li>
              <a href={helpUrl('categories/204528307')}>お問い合わせ</a>
            </li>
          </ul>
        </div>
      </div>

      <div className="site-footer__place-nav">
        <div className="row site-footer__nav site-footer__place-nav-list">
          <div className="col-sm-12 col-md-4">
            <h3 className="site-footer__nav-title sm-hide__guteter is-link">
              <a href={wwwUrl('/features/popular_meeting')}>人気の貸し会議室</a>
            </h3>
          </div>
          <div className="col-sm-12 col-md-8">
            <ul className="site-footer__nav-link sm-hide__guteter">
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular_meeting/cities/tokyo')}>
                  東京
                </a>
              </li>
              <li className="site-footer__place-nav-item">
                <a
                  href={wwwUrl(
                    '/features/popular_meeting/cities/shibuya-ku--tokyo/stations/1130205',
                  )}
                >
                  渋谷
                </a>
              </li>
              <li className="site-footer__place-nav-item">
                <a
                  href={wwwUrl(
                    '/features/popular_meeting/cities/shinjuku-ku--tokyo/stations/1130208',
                  )}
                >
                  新宿
                </a>
              </li>
              <li className="site-footer__place-nav-item">
                <a
                  href={wwwUrl(
                    '/features/popular_meeting/cities/toshima-ku--tokyo/stations/1130212',
                  )}
                >
                  池袋
                </a>
              </li>
              <li className="site-footer__place-nav-item">
                <a
                  href={wwwUrl(
                    '/features/popular_meeting/cities/shinagawa-ku--tokyo/stations/1130103',
                  )}
                >
                  品川
                </a>
              </li>
              <li className="site-footer__place-nav-item">
                <a
                  href={wwwUrl(
                    '/features/popular_meeting/cities/chiyoda-ku--tokyo/stations/1130222',
                  )}
                >
                  秋葉原
                </a>
              </li>
              <li className="site-footer__place-nav-item">
                <a
                  href={wwwUrl(
                    '/features/popular_meeting/cities/yokohama-shi--kanagawa/stations/1130105',
                  )}
                >
                  横浜
                </a>
              </li>
              <li className="site-footer__place-nav-item">
                <a
                  href={wwwUrl(
                    '/features/popular_meeting/cities/nagoya-shi--aichi/stations/1141101',
                  )}
                >
                  名古屋
                </a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular_meeting/cities/osaka')}>
                  大阪
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row site-footer__nav site-footer__place-nav-list">
          <div className="col-sm-12 col-md-4">
            <h3 className="site-footer__nav-title sm-hide__guteter is-link">
              <a href={wwwUrl('/features/popular')}>人気のレンタルスペース</a>
            </h3>
          </div>
          <div className="col-sm-12 col-md-8">
            <ul className="site-footer__nav-link sm-hide__guteter">
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular/cities/tokyo')}>東京</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular/cities/kanagawa')}>神奈川</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular/cities/chiba')}>千葉</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular/cities/aichi')}>愛知</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular/cities/osaka')}>大阪</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular/cities/kyoto')}>京都</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/popular/cities/fukuoka')}>福岡</a>
              </li>
            </ul>
          </div>
        </div>
        <div className="row site-footer__nav site-footer__place-nav-list">
          <div className="col-sm-12 col-md-4">
            <h3 className="site-footer__nav-title sm-hide__guteter is-link">
              <a href={wwwUrl('/features')}>特集・まとめ</a>
            </h3>
          </div>
          <div className="col-sm-12 col-md-8">
            <ul className="site-footer__nav-link sm-hide__guteter">
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/Cnr_fyMpN03A10Ny')}>格安</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/kitchen')}>キッチン付き</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/shouninzu')}>少人数</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/offsite_meeting')}>オフサイト</a>
              </li>
              <li className="site-footer__place-nav-item">
                <a href={wwwUrl('/features/birthdayparty')}>誕生日</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="row site-footer__app">
        <div className="col-sm-12 col-md-12">
          <div className="site-footer__static-app__download-banner">
            <a
              href="https://itunes.apple.com/app/apple-store/id973447544?pt=117136620&ct=spacemarket.com_banner_footer&mt=8"
              target="_blank"
            >
              <img
                src={imagePath('common/banner_appstore.png')}
                alt="Download on the App Store"
                width="180"
                height="53"
                className=""
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.spacemarket&referrer=utm_source%3Dspacemarket.com%252F%26utm_medium%3Dreferral%26utm_content%3Dbanner_footer"
              target="_blank"
            >
              <img
                src={imagePath('common/banner_googleplay.png')}
                alt="GET IT ON Google Play"
                width="180"
                height="55"
                className=""
              />
            </a>
          </div>
        </div>
      </div>
      <Links>
        <ComList>
          <ComListItem>
            <ComLink href="https://spacemarket.co.jp">運営会社</ComLink>
          </ComListItem>
          <ComListItem>
            <ComLink href="https://spacemarket.co.jp/recruit">採用情報</ComLink>
          </ComListItem>
          <ComListItem>
            <ComLink href={wwwUrl('/about/agreement')}>約款</ComLink>
          </ComListItem>
          <ComListItem>
            <ComLink href={wwwUrl('/about/tokushoho')}>
              特定商取引法に基づく表示
            </ComLink>
          </ComListItem>
        </ComList>
        <SnsList>
          <SnsListItem>
            <Sns href="https://www.facebook.com/spacemarketjp" target="">
              <i className="fa fa-facebook-square" />
            </Sns>
          </SnsListItem>
          <SnsListItem>
            <Sns href="https://twitter.com/spacemarketjp" target="">
              <i className="fa fa-twitter-square" />
            </Sns>
          </SnsListItem>
          <SnsListItem>
            <Sns href="https://www.instagram.com/spacemarketjp/" target="">
              <i className="fa fa-instagram" />
            </Sns>
          </SnsListItem>
        </SnsList>
        <Copyrights>
          <CopyrightsSmall>
            <img
              src={imagePath('footer/logo_spmkt.png')}
              height="12"
              width="113"
              alt="SPACEMARKET"
            />{' '}
            &copy; Space Market, Inc.{' '}
          </CopyrightsSmall>
        </Copyrights>
      </Links>
      <div className="site-footer__language_menu">
        <span className="site-footer__select">
          <div id="google_translate_element" />
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              // eslint-disable-line
              __html: `
                function googleTranslateElementInit() {
                  new google.translate.TranslateElement({pageLanguage: 'ja', includedLanguages: 'en,ja', autoDisplay: false, gaTrack: true, gaId: 'UA-46693491-1'}, 'google_translate_element');
                }
              `,
            }}
          />
          <script
            type="text/javascript"
            src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
            async
          />
        </span>
      </div>
    </div>
  </SiteFooterBottom>
)



// WEBPACK FOOTER //
// ./src/components/shared/footer/FooterBottom.jsx